import { Component, type PropsWithChildren } from 'react'
import { LoggerProvider, webLogger } from '@muse-web/logger'
import { sendErrorShow, shouldLogError } from '@core/analytics'

class ErrorLogger extends Component<PropsWithChildren> {
    componentDidCatch(error: unknown) {
        const caught = error instanceof Error ? error : new Error(String(error))

        if (shouldLogError('white_screen', caught.message)) {
            webLogger.error(caught)
            sendErrorShow('white_screen', error)
        }

        this.forceUpdate()
    }

    render() {
        const { children } = this.props

        return children
    }
}

export const AppLoggerProvider = ({ children }: PropsWithChildren) => (
    <LoggerProvider value={webLogger}>
        <ErrorLogger>{children}</ErrorLogger>
    </LoggerProvider>
)
